import axios from "axios";
import { EventResource } from "./resources/event.js";
const TRACKS_API_URL = "https://tracks.fluidattacks.com/";
class Tracks {
    event;
    client;
    constructor() {
        this.client = axios.create({ baseURL: TRACKS_API_URL });
        this.event = new EventResource(this.client);
    }
}
export { Tracks };
